var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirportMap = function SvgAirportMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8705 0.333008L16.7223 0.360786L11.7779 2.27745L6.2223 0.333008L1.00008 2.09227C0.805637 2.15708 0.666748 2.32375 0.666748 2.53671L0.666748 16.5367C0.666748 16.796 0.870452 16.9997 1.12971 16.9997L1.27786 16.9719L6.2223 15.0552L11.7779 16.9997L17.0001 15.2404C17.1945 15.1756 17.3334 15.0089 17.3334 14.796V0.795971C17.3334 0.536712 17.1297 0.333008 16.8705 0.333008ZM11.7779 15.1478L6.2223 13.1941L6.2223 2.18486L11.7779 4.13856L11.7779 15.1478Z",
    fill: "currentColor"
  })));
};
export default SvgAirportMap;